<template>
  <span id="add-shipment-rate" v-if="isVisible()">
    <el-button
      id="add-shipment-rate-button"
      class="button-action-default add-shipment-rate-margin-bottom"
      size="mini"
      type="success"
      plain
      @click="dialogVisible = true"
    >{{ $t('customerService.shipment.addRate') }}</el-button>

    <el-dialog
        id="add-shuttle-load-dialog"
        v-on:open="handleOpen"
        :title="$t('customerService.shipment.addRate')"
        :visible.sync="dialogVisible"
        width="60%"
        class="dialog-with-cols"
        append-to-body
        :close-on-click-modal="false"
    >
      <el-form :model="form" :rules="formRules" ref="form" label-position="right" label-width="150px" size="mini">
        <el-row :gutter="10">
          <el-col :span="10">
            <el-form-item :label="$t('customerService.shipment.chargeCode')" prop="chargeCode">
               <el-select
                filterable
                v-model="chargeSelected"
                value-key="Name"
                :loading="loading"
                id="form-charge-select"
                ref="charge-select"
                @change="selectCharge"
              >
                <el-option
                  v-for="charge in chargeList"
                  :key="charge.Name"
                  :label="charge.Code__c && charge.Name ? `${charge.Code__c} - ${charge.Name}`: ''"
                  :value="charge"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="4" class="list-name">
            <label class="margin-bottom-small-list-form">{{ $t('customerService.shipment.revenue') }}</label>
          </el-col>
          <el-col :span="3" class="list-name">
            <span class="span-small-list-form"> {{ form.revenue ? statusBoolean.yes.label : statusBoolean.no.label }} </span>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="10">
            <el-form-item :label="$t('customerService.shipment.rate') + ' (' + form.unitOfMeasure  +') '" prop="rate">
               <el-input-number
                  v-model="form.rate"
                  v-numeric-validation
                  :controls="false"
                  :precision="2"
                  @focus="$event.target.select()"
                  :min="0" :max="99999.99"
                  @change="calculateAmount"
                  class="inline-input width-100p"
                  id="form-rate"
                  ref="rate"
                ></el-input-number>
            </el-form-item>
          </el-col>

          <el-col :span="4" class="list-name">
            <label class="margin-bottom-small-list-form">{{ $t('customerService.shipment.quantity') }}</label>
          </el-col>
          <el-col :span="3" class="list-name">
            <span class="span-small-list-form" v-if="form.type == rateType.NON_REVENUE.value">
              {{ quantityCalculated | currency }}
            </span>
            <span class="span-small-list-form" v-else>
              {{ quantityCalculated }}
            </span>
          </el-col>

          <el-col :span="4" class="list-name">
            <label class="margin-bottom-small-list-form">{{ $t('customerService.shipment.amount') }}</label>
          </el-col>
          <el-col :span="3" class="list-name">
            <span class="span-small-list-form"> {{ amountCalculated | currency }} </span>
          </el-col>
        </el-row>
      </el-form>
      <div
          id="add-shipment-rate-dialog-footer"
          slot="footer"
          class="dialog-footer form-vertical-item flex-reverse-direction"
      >
        <el-button
            type="primary"
            id="save-shipment-rate-button"
            @click="submitForm()"
            size="mini"
        >{{ $t('customerService.shipment.addRate') }}</el-button>
        <el-button
            id="refresh-shipment-rate-button"
            @click="resetForm()"
            size="mini"
        >{{ $t('common.clear') }}</el-button>
      </div>
    </el-dialog>
  </span>
</template>

<script>
import { Message } from 'element-ui';
import constants from '@/utils/constants';
import apiConstants from '@/utils/apiConstants';
import selectService from '@/api/selectService';

export default {
  name: 'AddShipmentRate',
  props: {
    shipmentId: {
      type: Number,
      default: null
    },
    shipmentStatus: {
      type: Number,
      default: null
    },
    totalUnits: {
      type: Number,
      default: null
    },
    totalCubes: {
      type: Number,
      default: null
    },
    currentRates: {
      type: Array,
      default: null
    },
    shipmentNonRevenue: {
      type: Boolean,
      default: null
    },
    shipmentUomId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      dialogVisible: false,
      chargeList: [],
      chargeSelected: { Name: null },
      loading: false,
      amountCalculated: 0,
      quantityCalculated: 0,
      form: {
        shipmentId: this.shipmentId,
        chargeCode: '',
        chargeCodeName: '',
        type: '',
        glCode: '',
        rate: 0,
        revenue: false,
        unitOfMeasure: constants.SHIPMENT.RATE_UNIT_OF_MEASURE.CURRENCY,
      },
      formRules: {
        chargeCode: [
          {
            required: true,
            message: this.$t('customerService.shipment.error.chargeCodeRequired'),
            trigger: 'blur'
          }
        ],
        rate: [
          {
            required: true,
            message: this.$t('customerService.shipment.error.rateRequired'),
            trigger: 'blur'
          }
        ]
      },
      statusBoolean: constants.STATUS_BOOLEAN,
      rateType: constants.SHIPMENT.RATE_TYPE,
      uomPalletId: constants.UNIT_OF_MEASURE_LIST_BY_ID[2].value,
      uomBoxId: constants.UNIT_OF_MEASURE_LIST_BY_ID[1].value,
      uomBinId: constants.UNIT_OF_MEASURE_LIST_BY_ID[0].value
    };
  },
  methods: {
    isVisible() {
      const hasShipmentStatusErrorMasterOrRated = this.shipmentStatus === constants.SHIPMENT.STATUS[2].value || this.shipmentStatus === constants.SHIPMENT.STATUS[3].value || this.shipmentStatus === constants.SHIPMENT.STATUS[4].value;
      const hasPermission = this.$can(this.permissions.BILLING.EDIT_RATING);
      return hasShipmentStatusErrorMasterOrRated && hasPermission && !this.shipmentNonRevenue;
    },
    handleOpen() {
      this.form.shipmentId = this.shipmentId;
      this.searchChargeCodes();
      this.$nextTick(() => {
        this.resetForm();
      });
    },
    searchChargeCodes() {
      this.chargeList = [{}];
      this.loading = true;
      selectService.getList(apiConstants.END_POINTS.BILLING.SALESFORCE_CHARGES).then((response) => {
        if (response instanceof Array) {
          this.chargeList = this.chargeList.concat(response);
          this.loading = false;
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    selectCharge(charge) {
      this.form.chargeCode = charge.Code__c;
      this.form.chargeCodeName = charge.Name;
      this.form.type = charge.Charge_Type__c;
      this.form.glCode = charge.GL_Code__c;
      this.form.rate = charge.Rate__c;
      this.form.revenue = charge.Revenue_Charge__c;
      this.form.unitOfMeasure = charge.Units_of_Measure__c || '';
      this.calculateAmount();
    },
    // This calculation is Informative, Final Quantity and Amount is Calculated in Backend.
    calculateAmount() {
      // UNITS, PALLET, BIN
      if (this.useShipmentTotalUnits()) {
        this.quantityCalculated = this.totalUnits;
        this.amountCalculated = this.totalUnits * this.form.rate;
      } else if (this.form.type === this.rateType.CUBE.value) {
        // CUBES
        this.quantityCalculated = this.totalCubes;
        this.amountCalculated = this.totalCubes * this.form.rate;
      } else if (this.form.type === this.rateType.NON_REVENUE.value) {
        // NON_REVENUE
        let totalRevenueAmount = 0;
        for (const rate of this.currentRates) {
          if (rate.revenue && rate.type !== this.rateType.NON_REVENUE.value) {
            totalRevenueAmount += rate.amount;
          }
        }
        this.quantityCalculated = totalRevenueAmount;
        this.amountCalculated = totalRevenueAmount * (this.form.rate / 100);
      } else if (this.form.type === this.rateType.TRAILER.value || this.form.type === this.rateType.FLAT.value) {
        this.quantityCalculated = 1;
        this.amountCalculated = this.form.rate;
      } else {
        this.quantityCalculated = 0;
        this.amountCalculated = 0;
      }
    },
    useShipmentTotalUnits() {
      // RATE TYPE UNITS (Always applies no matter if the unitOfMeasureId is BIN or PALLET)
      return this.form.type === this.rateType.UNIT.value
        // RATE TYPE PALLET (Applies if the unitOfMeasureId of shipments is UNIT OR PALLET)
        || (this.form.type === this.rateType.PALLET.value
          && (this.shipmentUomId === this.uomPalletId || this.shipmentUomId === this.uomBoxId)
        )
        // RATE TYPE BIN (Applies if the unitOfMeasureId of shipments is BIN)
        || (this.form.type === this.rateType.BIN.value && this.shipmentUomId === this.uomBinId);
    },
    async submitForm() {
      const validForm = await this.$refs.form.validate().catch(() => {});
      if (!validForm) {
        return;
      }

      if (this.form.rate === 0) {
        const confirm = await this.$confirm(this.$t('customerService.shipment.confirmAddRateZero'), { confirmButtonText: this.$t('common.yes') }).catch(() => {});
        if (!confirm) {
          return;
        }
      }

      Message.closeAll();
      const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
      try {
        const response = await this.$store.dispatch('shipment/addRate', { ...this.form });
        this.$message.success(response.message);
        await this.$store.dispatch('shipment/searchRatings', {
          shipmentId: this.shipmentId,
          page: constants.TABLES.DEFAULT_PAGE,
          rows: constants.TABLES.DEFAULT_LIMIT,
          pageResults: true
        });
        this.resetForm();
      } finally {
        loading.close();
      }
    },
    resetForm() {
      this.chargeSelected = { Name: null };
      this.quantityCalculated = 0;
      this.amountCalculated = 0;
      this.form.chargeCode = '';
      this.form.chargeCodeName = '';
      this.form.type = '';
      this.form.glCode = '';
      this.form.rate = 0;
      this.form.revenue = false;
      this.form.unitOfMeasure = constants.SHIPMENT.RATE_UNIT_OF_MEASURE.CURRENCY;
      this.$refs.form.resetFields();
      this.$nextTick(() => {
        this.$refs.form.$el[0].focus();
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.add-shipment-rate-margin-bottom {
  float: right;
}

#add-shuttle-load-dialog {
  .el-form-item__content {
    .el-select {
      width: 100%;
    }
  }
}
</style>
